import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/withStyles";

import CookiesDisclaimer from "../CookiesDisclaimer";

import s from "./Layout.css";
class NewListLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <div className={s.overFlowHidden}>
        <div>{this.props.children}</div>
        <CookiesDisclaimer />
      </div>
    );
  }
}

export default withStyles(s)(NewListLayout);
